var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcecream1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7005 29.1984C16.6486 29.3284 16.5589 29.4398 16.4431 29.5182C16.3272 29.5967 16.1905 29.6386 16.0505 29.6386C15.9106 29.6386 15.7739 29.5967 15.658 29.5182C15.5422 29.4398 15.4525 29.3284 15.4005 29.1984L12.9005 23.0984L9.80054 15.3984H22.3005L19.2005 23.0984L16.7005 29.1984Z",
    fill: "url(#paint0_linear_20_111)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1006 12.1984C26.0602 12.9833 25.7411 13.7279 25.2006 14.2984C24.6407 14.8549 23.8896 15.1767 23.1006 15.1984H8.9006C8.12241 15.1725 7.38479 14.845 6.84363 14.2852C6.30247 13.7253 6.00016 12.977 6.0006 12.1984C5.98511 11.4212 6.27192 10.6683 6.8006 10.0984C7.07145 9.81402 7.39725 9.5876 7.75823 9.43289C8.11921 9.27818 8.50786 9.19843 8.9006 9.19843H9.7006C9.58733 8.29765 9.66701 7.38309 9.93434 6.51547C10.2017 5.64785 10.6505 4.84703 11.2511 4.1662C11.8517 3.48537 12.5903 2.9401 13.4178 2.56662C14.2452 2.19314 15.1427 2 16.0506 2C16.9585 2 17.8559 2.19314 18.6834 2.56662C19.5109 2.9401 20.2495 3.48537 20.8501 4.1662C21.4507 4.84703 21.8995 5.64785 22.1668 6.51547C22.4342 7.38309 22.5139 8.29765 22.4006 9.19843H23.1006C23.8962 9.19843 24.6593 9.51451 25.2219 10.0771C25.7845 10.6397 26.1006 11.4028 26.1006 12.1984Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_111",
    x1: 9.79195,
    y1: 29.6553,
    x2: 25.0314,
    y2: 19.4611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcecream1);
export default __webpack_public_path__ + "static/media/ice cream 1.17df89163515e4009ae81abd333f4253.svg";
export { ForwardRef as ReactComponent };